import React, { useEffect, useState } from 'react'

import {
    Box,
    Typography
} from '@mui/material'

import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    ptBR
} from '@mui/x-data-grid-pro'

import Loading from '../../Loading'
import useNotification from '../../Notification'
import api from '../../../api'

const VoiceExternalResources = ({ enterpriseId, resource }) => {
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])

    const isQueue = resource === 'queues'
    const title = isQueue ? 'Filas externas' : 'URAs externas'
    const endpoint = isQueue ? 'voice_queues' : 'voice_destinations'

    const getRows = async () => {
        setLoading(true)
        try {
            const response = await api.get(`/api/enterprises/${enterpriseId}/campaign/${endpoint}/`, {
                params: { telephony_backend: 'EXTERNAL' }
            })
            if (response.status === 200) {
                setRows(response.data.results || response.data || [])
            }
        } catch (error) {
            const message = error?.response?.data?.error || error?.response?.data?.detail || 'Não foi possível carregar os recursos externos.'
            useNotification('Ops!', message, 'danger')
            setRows([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (enterpriseId)
            getRows()
    }, [enterpriseId, resource])

    const columns = isQueue ? [
        { field: 'id', headerName: 'ID', flex: 0.4 },
        { field: 'name', headerName: 'Fila', flex: 1 },
        { field: 'description', headerName: 'Descrição', flex: 1 },
        { field: 'backend', headerName: 'Telefonia', flex: 0.5 },
    ] : [
        { field: 'mcdu', headerName: 'MCDU', flex: 0.5 },
        { field: 'name', headerName: 'URA', flex: 1 },
        { field: 'ivr_id', headerName: 'URA ID', flex: 0.5 },
        { field: 'ivr_module_id', headerName: 'Módulo ID', flex: 0.5 },
        { field: 'backend', headerName: 'Telefonia', flex: 0.5 },
    ]

    const CustomToolbar = () => (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
        </GridToolbarContainer>
    )

    return (
        <Box sx={{ height: 520, width: '100%' }}>
            <Loading loading={loading} />
            <Typography variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>
            <DataGridPro
                rows={rows.map((row, index) => ({ ...row, id: row.id || row.mcdu || index }))}
                columns={columns}
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                disableRowSelectionOnClick
                slots={{ toolbar: CustomToolbar }}
            />
        </Box>
    )
}

export default VoiceExternalResources
